module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_uncompleted-12fe3eb20667f2c5ecb9723b3ca4a2c4.png";